export const environment = {
  production: true,
  buildId: '3034325396820011',
  configFile: 'config.json',
};
